import React, { useContext } from 'react';

//context
import { WebEmbedContext } from '@/context/WebEmbed';

//components
import WidgetButton from '../WidgetButton/WidgetButton';
import ModalWrapper from  '@/components/modals/ModalWrapper';
import WebEmbedModal from  '@/components/modals/widgetPanel/WebEmbedModal';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';

//styling
import '../../../../css/widgetPanel/webEmbed.scss';



const WebEmbedWidget = () => {
    const {showEmbedModal, setShowEmbedModal, clearInputValues} = useContext(WebEmbedContext);

    return (
        <div className="widget-panel-item web-embed-widget">
            <WidgetButton type={WidgetType.WEB_EMBED} onClick={() => setShowEmbedModal(true)} />

            <ModalWrapper className="web-embed-modal-wrapper" isOpen={showEmbedModal} onRequestClose={(clearInputValues)}>
                <WebEmbedModal hideModal={clearInputValues}/>
            </ModalWrapper>
        </div>
    )
}
export default WebEmbedWidget